import React from "react";
import TextField, { TextFieldProps } from "@mui/material/TextField";
import InputAdornment from "@mui/material/InputAdornment";
import AttachFileIcon from "@mui/icons-material/AttachFile";
import { filesize } from "filesize";
import "../views/css/input-style.css";

interface FileInputCustomProps
    extends React.InputHTMLAttributes<HTMLInputElement> {
    file: File | null;
    setFile: React.Dispatch<React.SetStateAction<File | null>>;
}

const FileInputCustom = React.forwardRef<
    HTMLInputElement,
    FileInputCustomProps
>((props, ref) => {
    const { file, setFile, accept, ...other } = props;

    const labelText = React.useMemo<string>(() => {
        if (file) return file.name;
        else if (props.placeholder) return props.placeholder;
        else return "Choose File";
    }, [file, props.placeholder]);

    return (
        <label
            htmlFor={props.id}
            style={{
                flexGrow: 1,
                position: "relative",
                display: "flex",
                alignItems: "center",
            }}
        >
             {/* style={{ position: "absolute", fontSize: "10px" }}  */}
            <span className="span-title">{labelText}</span>

            <input
                {...other}
                type="file"
                accept={accept}
                id={props.id}
                onChange={(event) =>
                    setFile(event.target.files && event.target.files[0])
                }
                style={{ opacity: 0 }}
            />
        </label>
    );
});

const FileInput = (props: TextFieldProps) => {
    const [file, setFile] = React.useState<File | null>(null);

    return (
        <TextField
            {...props}
            fullWidth
            type="file"
            InputProps={{
                startAdornment: (
                    <InputAdornment position="start">
                        <AttachFileIcon />
                    </InputAdornment>
                ),
                inputComponent: FileInputCustom as any,
                endAdornment: (
                    <InputAdornment position="end">
                        {file &&
                            filesize(file.size, {
                                base: 2,
                                standard: "jedec",
                            }).toString()}
                    </InputAdornment>
                ),
                inputProps: {
                    file: file,
                    setFile: setFile,
                    accept: props.inputProps?.accept,
                },
            }}
            variant="outlined"
        />
    );
};

export default FileInput;
